$.fn.validate = function(opts) {
    let _this = this;
    let validationRequestTimer;

    _this.options = {
        submitButton: _this.find('button[type="submit"]'),
        validationQueryStringIdentifier: 'validate=1'
    };

    _this.options = $.extend({}, _this.options, opts);
    _this.xhrPool = [];

    _this.validate = function() {
        _this.on("submit", function (e) {
            e.preventDefault();

            _this.options.submitButton.attr('disabled', 'disabled');
            $('<i class="fas fa-spinner fa-spin ml-2"></i>').appendTo(_this.options.submitButton);
        });

        let $firstInput = _this.find('input:first');
        $firstInput.focus();
        _this.options.submitButton.attr('disabled', 'disabled');
        _this.doAjaxValidationRequest($firstInput, false);

        _this.find('input').each(function (index, field) {
            _this.validateField(field)
        })
    };

    _this.validateField = function (field) {
        $(field).on("keyup", function (event) {
            if(event.keyCode !== 13) {
                window.clearTimeout(validationRequestTimer);
                validationRequestTimer = window.setTimeout(() => {
                    _this.doAjaxValidationRequest($(event.target), true);
                    validationRequestTimer = null;
                }, 350);
            }
        });
    };

    _this.doAjaxValidationRequest = function (field, showErrors) {
        $.ajax({
            beforeSend: function (jqXHR) {
                $.each(_this.xhrPool, function(idx, jqXHR) {
                    jqXHR.abort();
                });

                _this.xhrPool.push(jqXHR);
            },
            url: window.location.pathname + '?' + _this.options.validationQueryStringIdentifier,
            method: 'POST',
            cache: false,
            data: _this.serialize(),
            success: function (errors) {
                _this.handleValidationErrors(field, showErrors, errors);
            }
        })
    };

    _this.handleValidationErrors = function (field, showErrors, errors) {
        if (showErrors === false) {
            if ($.isEmptyObject(errors)) {
                _this.options.submitButton.removeAttr('disabled');
            }

            return;
        }

        _this.find('input').removeClass('is-invalid');
        _this.find('.invalid-feedback').remove();
        if ($.isEmptyObject(errors)) {
            _this.options.submitButton.removeAttr('disabled');

            return;
        }

        $.each(errors, function (fieldName, error) {
            let $field = $('input[name$="' + fieldName + ']"]');
            let $parentEl = $field.parent();
            $parentEl.find('.invalid-feedback').remove();

            $field.addClass('is-invalid');
            $('<div class="invalid-feedback"><ul class="list-unstyled mb-0"><li>'+error+'</li></ul></div>').appendTo($parentEl);

            _this.options.submitButton.attr('disabled', 'disabled');
        });
    };

    _this.validate();
};
